import { updateTicketState } from "../../services/Administrative/ticketsService";

export const useUpdateTicketState = () => {
    const updateState = async (newState: string, uniqueCode: string, cancelReason: string) => {
        try {
            return await updateTicketState(newState, uniqueCode, cancelReason);
        } catch (error) {
            throw Error("Error al actualizar el estado del ticket");
        }
    };

    return { updateState };
};
